import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  FinancialPeriodParams,
  OtherCostsResponse
} from "../financialReport.types";
import { requestOtherCosts } from "./otherCosts.request";

const useOtherCosts = (
  params: FinancialPeriodParams,
  options?: QueryOptions<OtherCostsResponse, ApiServiceError<ApiError>>
) => {
  return useQuery({
    queryKey: ["other-costs", params],
    queryFn: async () => await requestOtherCosts(params),
    onError: toastServerError,
    ...options
  });
};

export default useOtherCosts;
